import { v1http, http4 } from "@/plugins/api";
import { token } from "@/services/token";
import { httpWithoutBearer } from "../plugins/api";

const base = "bff/axi";
const baseComposer = "transaction-composer";

export const getRekanBisnis = (nomorAxiId) => {
  const url = `/${base}/rekanbisnis/${nomorAxiId}`;
  const headers = {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json",
  };

  return v1http.get(url, { headers });
};

export const searchAxi = (nomorAxiId) => {
  const url = `/profile/detail-axis/search?nomor_axi_id=${nomorAxiId}`;
  const headers = {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json",
  };

  return v1http.get(url, { headers });
};

export const getAxiDetail = (profileId) => {
  const url = `/axiRegDetail/${profileId}`;
  // const headers = {
  //   "Accept": "application/vnd.api+json",
  //   "Content-Type": "application/vnd.api+json"
  // }

  return http4.get(url);
};

export const updateAxiForGalaxi = (payload) => {
  const url = `/${baseComposer}/axi/edit-event-only`;

  const formData = new FormData();

  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });

  const headers = {
    "Content-Type": "application/vnd.api+json",
  };

  return v1http.post(url, formData, {
    headers,
  });
};

export const resendEmailGalaxi = () => {
  const url = `/${baseComposer}/axi/resend-email-event-only`;

  const headers = {
    "Content-Type": "application/vnd.api+json",
  };

  return v1http.post(url, {
    headers,
  });
};

export const suksesEmail = () => {
  const url = `/${baseComposer}/axi/sukses-email-event-only`;
  const headers = {
    Accept: "application/vnd.api+json",
    Authorization: `Bearer ${token.accessToken}`,
  };

  return v1http.post(url, { headers });
};

export const getSnkPdf = () => {
  const url = "/transaction-composer/images/10";

  return httpWithoutBearer.get(url, {
    responseType: "arraybuffer",
  });
};
